"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNav = exports.MenuItem = exports.IconExternal = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _reactRouterDom = require("react-router-dom");

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _browserHistory = require("../../../browserHistory");

var _ExternalLinks = require("./ExternalLinks");

/* eslint-disable @typescript-eslint/strict-boolean-expressions */
const IconExternal = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 3L16.293 6.293L9.293 13.293L10.707 14.707L17.707 7.707L21 11V3H13Z",
    fill: "#FBFCFD"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 19H5V5H12L10 3H5C3.897 3 3 3.897 3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V14L19 12V19Z",
    fill: "#FBFCFD"
  }));
};

exports.IconExternal = IconExternal;
const MenuItem = (0, _styledComponents.default)(_blocks.PrimaryNavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 ${_blocks.spacing.snug};
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 100%;
  font-weight: normal;
  /* neutral 1 */
  color: hsl(206, 30%, 98.8%);
  font-style: normal;
  text-decoration: none;
  border-radius: 4px;

  &[aria-current='page'] {
    pointer-events: none;
  }

  &:hover {
    /* neutral dark 8 */
    box-shadow: inset 0 0 0 1px hsl(207, 5.6%, 31.6%);
    background: none;
  }

  &:focus-visible {
    /* neutral dark 8 */
    box-shadow: 0 0 0 3px rgba(#fff, 0.2), 0 0 0 1px hsl(207, 5.6%, 31.6%);
  }

  &:active {
    /* neutral dark 7 */
    box-shadow: inset 0 0 0 1px hsl(203, 6%, 24.3%);
  }

  &.is-active {
    /* neutral dark 5 */
    background-color: hsl(199, 6.4%, 17.9%);

    &:hover {
      box-shadow: none;
    }
  }
`;
exports.MenuItem = MenuItem;

const PrimaryNav = ({
  links,
  userAccess
}) => {
  const qs = _queryStringForAll.default.parse(_browserHistory.history.location.search);

  const siteIdsSuffix = 'sites' in qs ? _queryStringForAll.default.stringify({
    sites: qs.sites
  }) : undefined;
  return /*#__PURE__*/_react.default.createElement(_blocks.ControlGroup, {
    tight: true
  }, links.map(({
    href,
    label
  }) => /*#__PURE__*/_react.default.createElement(MenuItem, {
    as: _reactRouterDom.NavLink,
    key: href,
    activeClassName: "is-active",
    "data-cy": "PrimaryNav-item",
    to: siteIdsSuffix ? {
      pathname: href,
      search: siteIdsSuffix
    } : href,
    href: href
  }, label(_core.i18n))), /*#__PURE__*/_react.default.createElement(_ExternalLinks.ExternalLinks, {
    userAccess: userAccess
  }));
};

exports.PrimaryNav = PrimaryNav;
PrimaryNav.defaultProps = {
  className: ''
};